import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IParamsField {
	changeDropboxPushParams: (value: string) => void;
}

const ParamsField: React.FC<IParamsField> = ({ changeDropboxPushParams }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterParams') }], [t]);

	return (
		<FormInput
			testId="ParamsField"
			name="dropboxPushParams"
			label="paramsLabel"
			onChange={changeDropboxPushParams}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ParamsField);
